import {
  FormControl,
  Icon,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
  InputRightElement,
  VisuallyHidden,
  InputLeftAddon,
  forwardRef,
  FormErrorMessage,
  FormErrorMessageProps,
} from "@chakra-ui/react";
import * as React from "react";
import { IconType } from "react-icons/lib";

interface Props extends InputProps {
  label: string;
  hideLabel?: boolean;
  leftIcon?: IconType;
  leftAddon?: string;
  inputRightElement?: React.ReactNode;
  errorMessage?: string;
  errorMessageProps?: FormErrorMessageProps;
  floatingError?: boolean;
}
export const InputText = forwardRef<Props, "input">(
  (
    {
      hideLabel = true,
      label,
      leftIcon,
      leftAddon,
      inputRightElement,
      errorMessage,
      floatingError = false,
      ...props
    }: Props,
    ref
  ): React.ReactElement => {
    return (
      <FormControl
        isInvalid={props.isInvalid}
        {...(floatingError
          ? {}
          : {
              display: "grid",
              gridTemplateRows: "1fr 2rem",
            })}
      >
        {hideLabel ? (
          <VisuallyHidden>
            <FormLabel>{label}</FormLabel>
          </VisuallyHidden>
        ) : (
          <FormLabel>{label}</FormLabel>
        )}
        <InputGroup>
          {leftAddon && <InputLeftAddon children={leftAddon} />}
          {leftIcon && (
            <InputLeftElement
              children={<Icon as={leftIcon} color="gray.500" />}
            />
          )}
          <Input ref={ref} {...props}></Input>
          {inputRightElement && (
            <InputRightElement marginX={2} children={inputRightElement} />
          )}
        </InputGroup>
        <FormErrorMessage
          {...(floatingError
            ? {
                bg: "white",
                paddingX: "4",
                rounded: "xl",
                position: "absolute",
                zIndex: "1",
              }
            : {})}
          {...props.errorMessageProps}
        >
          {errorMessage ?? " "}
        </FormErrorMessage>
      </FormControl>
    );
  }
);
